import React, { useEffect, useRef } from "react";
import { useReactToPrint } from "react-to-print";
import robotoStyles from "../fonts/RobotoFont.styles";
import overpassStyles from "../fonts/OverpassFont.styles";
import barlowStyles from "../fonts/BarlowFont.styles";
import printableStyles from "../styles/Printable.styles";

const Printable = ({
	showPreview,
	children,
	onBeforeGetContent,
	onBeforePrint,
	onAfterPrint,
	fileName,
	pageStyle
}) => {
	const classes = printableStyles();
	robotoStyles();
	overpassStyles();
	barlowStyles();

	const boxScoreRef = useRef();

	const doPrint = useReactToPrint({
		content: () => boxScoreRef.current,
		onBeforeGetContent,
		onBeforePrint,
		onAfterPrint,
		documentTitle: fileName,
		// Only when set: react-to-print merges options over its defaults, so an
		// explicit undefined would wipe its default page style for every print
		...(pageStyle && { pageStyle })
	});

	useEffect(() => {
		if (showPreview) {
			doPrint();
		}
	}, [showPreview]);

	return showPreview ? (
		<div ref={boxScoreRef} className={classes.printOnly}>
			{children}
		</div>
	) : null;
};

export default Printable;
